import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

export const title = css`
  padding: ${size[64]} 0;
  font-weight: 700;
  font-size: ${pxToRem(45)};

  ${breakpoint.up('smMd')} {
    padding: ${size[112]} 0;
    font-size: ${pxToRem(60)};
  }
`
export const containersWrapper = css`
  display: flex;
  flex-direction: column;
  gap: ${size[48]};
  margin: ${size[48]} auto;

  ${breakpoint.up('smMd')} {
    flex-direction: row;
    justify-content: space-between;
    margin: ${size[80]} auto;
  }
`

export const contactContainer = css`
  flex: 1;
`
export const contact = css`
  font-size: ${pxToRem(32)};
  font-weight: 500;
  margin-bottom: 0;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(48)};
    letter-spacing: -1px;
  }
`
export const contactLabel = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
  font-size: ${pxToRem(12)};
  font-weight: 400;
  margin-bottom: ${size[32]};

  ${breakpoint.up('smMd')} {
    letter-spacing: 2px;
    font-size: ${pxToRem(16)};
  }
`
export const contactLink = (theme: Theme) => css`
  color: ${theme.palette.text.title};
  font-weight: 400;
`
export const contactInfo = css`
  display: flex;
  align-items: center;
  margin-bottom: ${size[18]};
  margin-left: ${size[18]};
  font-size: ${pxToRem(20)};
  font-weight: 400;
  gap: ${size[24]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(26)};
    margin-bottom: ${size[16]};
    margin-left: 0;
  }
`

export const infoContainer = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  background-color: ${theme.palette.primary.maxContrast};
  padding: ${size[24]};
  border-radius: ${theme.borderRadius.md};
  flex: 1;
  margin-bottom: ${size[12]};

  ${breakpoint.up('smMd')} {
    margin-bottom: ${size[24]};
  }
`
export const infoTitle = (theme: Theme) => css`
  font-size: ${pxToRem(18)};
  color: ${theme.palette.text.titleReversed};
  margin-bottom: ${size[16]};
  line-height: 1;
  font-weight: 500;

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(26)};
  }
`
export const infoDescription = (theme: Theme) => css`
  color: ${theme.palette.text.titleReversed};
  font-size: ${pxToRem(14)};
  margin-bottom: ${size[16]};

  ${breakpoint.up('smMd')} {
    font-size: ${pxToRem(18)};
  }
`
export const infoLink = css`
  max-width: 185px;
`
